import React, {useEffect, useRef, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../FileUploads/FileUpload";
import SuccessModal from "../../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../../layout/dashboardMenu";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import Camera from "react-html5-camera-photo";
import Moment from "moment/moment";
import {parse} from "dotenv";


const AMVisit = ({
                     match,
                     history,
                     documentUploadUrlPublic,
                     documentUrlDataPublic,
                     markAttendance,
                     attendance,
                     getFse,
                     fseDetails= [],
                     isCheckout,
                     isCheckoutDetails = [],
                     tollById,
                     tollView= [],
                     fseOTPResponse= [],
                     fseOtp,
                     activitySave,
                     saveActivityResponse= []
                 }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        competitor: [],
        fse_details: []
    }])

    const [successMessage, setSuccessMessage] = useState('')
    const [backUrl, setBackUrl] = useState('')
    const [openCheckIn, setOpenCheckIn] = useState(false)
    const [checkInText, setCheckInText] = useState('Check In')
    const [competitor, setCompetitor] = useState([{name:'', bank: '', employee_type: '', no_of_fse: '', salary: '', min_tags: '', tag_sold: '', upload_proof: ''}])
    const [open, setOpen] = useState(false);
    const [currentIndex, serCurrentIndex] = useState('')
    const [fse, setFSE] = useState([{phone_no: '', otp: '', text: "Send OTP", selfie: ''}])
    const [activityId, setActivityId] = useState('')
    const [roleId, setRoleId] = useState(0);
    const [hours, setHours] = useState(2)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            if(window.localStorage.fse_details && window.localStorage.fse_details.length > 0){
                setFSE(JSON.parse(window.localStorage.fse_details))
            }
            setRoleId(window.localStorage.role_id);
            await getFse()
            await isCheckout('', match?.params?.account_id, match?.params?.pjp_id)
            await tollById(match?.params?.account_id)
            setIsLoading(false)
        })()
    }, [])


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityResponse?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
            toast.success("Activity is completed.")
            delete window.localStorage.fse_details
            setOpenCheckIn(true)
            setCheckInText("Check out")
        } else if (saveActivityResponse?.status !== undefined && saveActivityResponse?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(saveActivityResponse?.message)
        }
    }, [saveActivityResponse])

    useEffect(() => {
        if(isCheckoutDetails?.data && Object.keys(isCheckoutDetails?.data).length > 0){
            // check in already done on toll for meeting
            setActivityId(isCheckoutDetails?.data?.activity_id)
            if(isCheckoutDetails?.data?.toll_submission_pjp_id === null){
                toast.error("Check out from pending activity on toll.");
                setTimeout(() => {
                    window.location.href=`fast-tag-toll-activity-complete/${isCheckoutDetails?.data?.activity_id}/${isCheckoutDetails?.data?.account_id}`;
                }, 1000)
            } else if(!isCheckoutDetails?.data?.check_out_lat && parseInt(isCheckoutDetails?.data?.status) === 2){
                setOpenCheckIn(true)
                setCheckInText('Check out')
            } else if (parseInt(isCheckoutDetails?.data?.toll_submission_pjp_id) !== parseInt(match?.params?.pjp_id)) {
                toast.error("Check out from pending pjp on toll.");
                setTimeout(() => {
                    window.location.href=`pjp-approved-list/${match?.params?.request_id}/${window.localStorage.user_id}`;
                }, 1000)
            }
            else {
                // check in already done for PJP then closed to continue pjp
                setOpenCheckIn(false)
            }
        } else if(isCheckoutDetails?.data && Object.keys(isCheckoutDetails?.data).length === 0){
            // check check in is not done
            setOpenCheckIn(true)
            setCheckInText('Check In')
        }
    }, [isCheckoutDetails])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['activity_type_id'] = 15
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        list['status'] = 2
        list['meta_data'] = competitor
        list['fse_details'] = fse
        list['closure_date'] = new Date();
        list['pjp_id'] = match?.params?.pjp_id
        list['id'] = activityId
        list['role_id'] = window.localStorage.role_id

        fse.map(val => {
            if(!val?.selfie){
                toast.warning("Selfie is missing for phone no "+val?.phone_no);
                return false
            }
        })
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }
        list['account_id'] = match?.params?.account_id
        setIsLoading(true)
        await activitySave(list)
        setIsLoading(false)
    }

    useEffect(() => {
        if (parseInt(attendance?.status) === 200) {
            toast.success("Check In is marked successfully")
            setOpenCheckIn(false)
            setTimeout(() => {
                window.location.href=`pjp-approved-list/${match?.params?.request_id}/${window.localStorage.user_id}`;
            }, 1000)
        } else if (parseInt(attendance?.status) !== 200){
            toast.warning(attendance?.message)
        }
    }, [attendance])

    const handleCompetitorAdd = () => {
        setCompetitor([
            ...competitor,
            {name:'', bank: '', employee_type: '', no_of_fse: '', salary: '', min_tags: '', tag_sold: '', upload_proof: ''}
        ])
    }

    const handleRemoveCompetitor = (e, index) => {
        const list = [...competitor]
        list.splice(index, 1);
        setCompetitor(list);
        e.preventDefault()
    }

    const handleFSEAdd = () => {
        setFSE([
            ...fse,
            {phone_no: '', otp: '', text: "Send OTP", selfie: ''}
        ])
    }

    const handleRemoveFSE = (e, index) => {
        const list = [...fse]
        list.splice(index, 1);
        setFSE(list);
        setIsLoading(true)
        window.localStorage.fse_details = JSON.stringify(list)
        setIsLoading(false)
    }

    const handleFSEInput = (key, value, index) => {
        if(key === "phone_no" && value.length > 10){
            toast.warning("Phone no can't be greater than 10 digit");
            return false;
        }
        const list = [...fse];
        let isDuplicate = false
        list[index][key] = value;
        setFSE(list)
        window.localStorage.fse_details = JSON.stringify(fse)
    }

    const handleCompetitorInput = (key, value, index) => {
        const list = [...competitor];
        list[index][key] = value;
        setCompetitor(list)
    }

    const handleOtpGeneration = async (phoneNo, index) => {
        if(!phoneNo){
            toast.error("Please enter phone no of FSE.")
            return false
        }
        setIsLoading(true)
        let res = await fseOtp({phone_no: phoneNo})
        if(res){
            handleFSEInput('text', 'Check OTP', index)
            handleFSEInput('otp', res, index)
        }
        setIsLoading(false)
    }

    const resentOTP = async (phoneNo) => {
        setIsLoading(true)
        await fseOtp({phone_no: phoneNo})
        setIsLoading(false)
    }
    const handleConfirmationModal = (index) => {
        serCurrentIndex(index)
        handleFSEInput('selfie', '', index)
        setOpen(true)
    }

    const handleCloseConfirmationModal = () => {
        setIsLoading(true)
        serCurrentIndex('')
        setOpen(false)
        setIsLoading(false)
    }

    useEffect(() => {
        if(documentUrlDataPublic?.file_url !== undefined && currentIndex !== ''){
            handleFSEInput('selfie', documentUrlDataPublic?.file_url, currentIndex)
        }
    }, [documentUrlDataPublic]);

    const diff_hours = (dt2, dt1) => {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60);
        return Math.abs(Math.round(diff));
    }

    useEffect(() => {
        if (isCheckoutDetails?.data !== undefined && Object.keys(isCheckoutDetails?.data).length > 0 &&
            parseInt(isCheckoutDetails?.data?.toll_submission_pjp_id) === parseInt(match?.params?.pjp_id)) {
            setOpenCheckIn(false)
            let current = new Date();
            let checkInTime = new Date(Moment(isCheckoutDetails?.data?.check_in_date).format('Y-MM-DD H:mm:ss'))
            let spendHours = diff_hours(checkInTime, current)
            setHours(spendHours)
            // 30 ASM
            if(parseInt(roleId) === 30 && spendHours < 1){
                toast.warning("You can't complete this toll visit before 1 hours")
            } else if(parseInt(roleId) === 29 && spendHours < 3){
                // AM
                toast.warning("You can't complete this toll visit before 3 hours")
            }
        }
    }, [isCheckoutDetails])

    return (
        <>
            {/*<SuccessModal*/}
            {/*    isOpen={isSuccessModalOpen}*/}
            {/*    msg={successMessage}*/}
            {/*    url={match?.params?.lead_id !== undefined ? `v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}/${match?.params?.lead_id}` :`v2-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}*/}
            {/*/>*/}

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
                url={backUrl}
            />
            <Loader isLoading={isLoading}/>
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Selfie</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {handleCloseConfirmationModal()}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {window.localStorage.fse_details && JSON.parse(window.localStorage.fse_details) && JSON.parse(window.localStorage.fse_details)[currentIndex]['selfie'] ?
                                        <img alt="selfie" src={JSON.parse(window.localStorage.fse_details)[currentIndex]['selfie']}/>
                                        :
                                        <Camera
                                            idealFacingMode={'user'}
                                            idealResolution={{
                                                width: 600,
                                                height: 480
                                            }}
                                            onTakePhoto={(dataUri) => {
                                                (async () => {
                                                    setIsLoading(true)
                                                    await documentUploadUrlPublic({ base_64_file: dataUri })
                                                    setIsLoading(false)
                                                })()
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Toll Visiting"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {openCheckIn ?
                                <>
                                    <div className="popup-box">
                                        <div className="box">
                                            <DistanceCalculator
                                                isMapShow={true}
                                                calculateDistance={markAttendance}
                                                moduleType={'Fasttag Toll'}
                                                checkInText={checkInText}
                                                // activityId={saveActivityRes?.data?.id !== undefined ? saveActivityRes?.data?.id : null}
                                                documentUploadUrlPublic={documentUploadUrlPublic}
                                                documentUrlDataPublic={documentUrlDataPublic}
                                                accountId={match?.params?.account_id}
                                                pjpId={match?.params?.pjp_id}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                    <h1 className="h3 mb-0 text-black-100"><b>Toll Details</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-md-6 float-field ">
                                                                <input type="number"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={tollView?.data?.fast_tag_toll_no}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Plaza Id
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={tollView?.data?.client_name}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Plaza Name
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6 float-field ">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       value={tollView?.data?.city_name}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    City
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                    <h1 className="h3 mb-0 text-black-100"><b>FSE Catchup</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            {fse && fse.map((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="number"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   // disabled={val?.phone_no}
                                                                                   onChange={(e) => {handleFSEInput('phone_no', e.target.value, i)}}
                                                                                   value={val?.phone_no ?? ""}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Phone No
                                                                            </label>
                                                                        </div>
                                                                        {/*<div className="col-md-6 float-field ">*/}
                                                                        {/*    <input type="text"*/}
                                                                        {/*           className="form-control form-control-user"*/}
                                                                        {/*           placeholder=" "*/}
                                                                        {/*           onChange={(e) => {handleFSEInput('otp', e.target.value, i)}}*/}

                                                                        {/*    />*/}
                                                                        {/*    <label className="large-label float-lb">*/}
                                                                        {/*        Enter OTP*/}
                                                                        {/*    </label>*/}
                                                                        {/*</div>*/}

                                                                        {/*<div className="col-md-3 mb-4">*/}
                                                                        {/*    <a className={`btn btn-primary btn-user btn-block ${val?.text === 'OTP Verified' ? "bg-green text-white" :""}`} onClick={() => {handleOtpGeneration(val?.phone_no, i)}}*/}
                                                                        {/*       disabled={val?.text === 'OTP Verified'}>*/}
                                                                        {/*        {val?.text}*/}
                                                                        {/*    </a>*/}
                                                                        {/*</div>*/}
                                                                        {/*{val?.text === "Check OTP" &&*/}
                                                                        {/*    <div className="col-md-3">*/}
                                                                        {/*        <a className="btn btn-primary btn-user btn-block" onClick={() => {resentOTP(val?.phone_no)}}*/}
                                                                        {/*           disabled={val?.text === 'OTP Verified'}>*/}
                                                                        {/*            Resend OTP*/}
                                                                        {/*        </a>*/}
                                                                        {/*    </div>*/}
                                                                        {/*}*/}
                                                                        <div className="col-md-3 mb-4">
                                                                            {val?.selfie ?
                                                                                // eslint-disable-next-line react/jsx-no-target-blank
                                                                                <a className="btn btn-primary btn-user btn-block" href={val?.selfie} target="_blank">View</a>
                                                                                :

                                                                                <a className="btn btn-primary btn-user btn-block" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => {handleConfirmationModal(i)}}>
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="16" height="16"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-camera mr-2"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path
                                                                                            d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z"/>
                                                                                        <path
                                                                                            d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
                                                                                    </svg> Capture Selfie
                                                                                </a>
                                                                            }
                                                                        </div>
                                                                        <div className="col-md-3 mb-4">
                                                                            {val?.selfie &&
                                                                                <a className="btn btn-primary btn-user btn-block bg-red" data-toggle="modal" data-target="#exampleModalCenter" onClick={() => {handleConfirmationModal(i)}}>
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="16" height="16"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-camera mr-2"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path
                                                                                            d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z"/>
                                                                                        <path
                                                                                            d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/>
                                                                                    </svg>
                                                                                    Remove Selfie
                                                                                </a>
                                                                            }
                                                                        </div>
                                                                        <div
                                                                            className="btn-box mb-4" style={{"width": "100%"}}>
                                                                            {fse.length !== 1 &&
                                                                                <button
                                                                                    onClick={(e) => handleRemoveFSE(e, i)}
                                                                                    className="btn btn-sm btn-danger ml-3">Remove FSE
                                                                                </button>
                                                                            }
                                                                            {fse.length - 1 === i &&
                                                                                <button
                                                                                    className="btn btn-sm btn-primary ml-3"
                                                                                    onClick={(e) => handleFSEAdd()}>Add FSE
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    </>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                    <h1 className="h3 mb-0 text-black-100"><b>Add Competitor Analysis</b></h1>
                                                </div>
                                                {competitor.map((val, i) => {
                                                    return (
                                                        <>
                                                            <div className="card-body bg-white">
                                                                <div className="user">
                                                                    <div className="form-group row">
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handleCompetitorInput('name', e.target.value, i,)
                                                                                   }}
                                                                                   required={true}

                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Competitor Name
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="text"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                        handleCompetitorInput('bank', e.target.value, i,)
                                                                                    }}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                FASTag Bank Name
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                            <select
                                                                                className="form-control form-control-user"
                                                                                onChange={(e) => {
                                                                                    handleCompetitorInput('employee_type', e.target.value, i,)
                                                                                }} required={true}>
                                                                                <option value="">Select Employee Type</option>
                                                                                <option value="Salaried">Salaried</option>
                                                                                <option value="Commission">Commission</option>
                                                                                <option value="Salaried + Commission">Salaried + Commission</option>
                                                                            </select>
                                                                            <label className="large-label float-lb">
                                                                                Employee Type <i className="bi bi-asterisk astrick-icon"></i>
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="number"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handleCompetitorInput('no_of_fse', e.target.value, i,)
                                                                                   }}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Number of FSEs
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handleCompetitorInput('salary', e.target.value, i,)
                                                                                   }}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Monthly Salary
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handleCompetitorInput('min_tags', e.target.value, i,)
                                                                                   }}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Min. Number of tags sold to be eligible for salary
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-md-6 float-field ">
                                                                            <input type="float"
                                                                                   className="form-control form-control-user"
                                                                                   placeholder=" "
                                                                                   onChange={(e) => {
                                                                                       handleCompetitorInput('tag_sold', e.target.value, i,)
                                                                                   }}
                                                                                   required={true}
                                                                            />
                                                                            <label className="large-label float-lb">
                                                                                Monthly tags sold
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-sm-6 mtk-1 float-field mb-3" key={i}>
                                                                            <FileUpload
                                                                                id={`addAttachment`}
                                                                                accept=".png,.jpg,.jpeg"
                                                                                documentUploadUrl={documentUploadUrlPublic}
                                                                                documentUrlData={documentUrlDataPublic}
                                                                                onChange={(e, val) => {
                                                                                    handleCompetitorInput('upload_proof', e, i,)
                                                                                }}
                                                                                required={true}
                                                                                prefilledFilename={""}
                                                                                multiple={true}
                                                                            >
                                                                                Upload Proof
                                                                            </FileUpload>
                                                                        </div>
                                                                        <div
                                                                            className="btn-box mb-4" style={{"width": "100%"}}>
                                                                            {competitor.length !== 1 &&
                                                                                <button
                                                                                    onClick={(e) => handleRemoveCompetitor(e, i)}
                                                                                    className="btn btn-sm btn-danger ml-3">Remove
                                                                                </button>
                                                                            }
                                                                            {competitor.length - 1 === i &&
                                                                                <button
                                                                                    className="btn btn-sm btn-primary ml-3"
                                                                                    onClick={(e) => handleCompetitorAdd()}>Add
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}

                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-4 d-flex">
                                            <button className="btn btn-primary btn-user btn-block submit-btn"
                                                    disabled={ (parseInt(roleId) === 30 && parseInt(hours) < 1) || (parseInt(roleId) === 29 && parseInt(hours) < 3)}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </>
                            }

                            {/*<button type="button" className="btn btn-primary" data-toggle="modal"*/}
                            {/*        data-target="#exampleModal">*/}
                            {/*    Launch demo modal*/}
                            {/*</button>*/}


                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Activity</h1>
                            </div> */}

                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default AMVisit